import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  createTheme,
  ThemeProvider,
  Button
} from "@mui/material";
import dayjs from "dayjs";
import PrimaryButton from "./primaryButton";
import SecondaryButton from "./secondaryButton";
import ThankyouIcon from '../assets/images/OBJECTS.svg'
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { handleDecodeJSON, handleEncodeJson } from "../utils/encodeDecodeJson";
import feedbackActions from "../Redux/feedback/actions";
import { useDispatch, useSelector } from "react-redux";
import useFetchCandidateTokenDetails from "../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../utils/auditLog";
import checkAuth from "./CheckAuth";

export default function ThankYou() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { heartBeat } = useSelector((state) => state.examReducer);
  const questionsList = useSelector(
    (state) => state.examReducer.questionsAndOptions?.questionsList);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [isReady, setIsReady] = useState(false);
  let candidateData = JSON.parse(sessionStorage.getItem("candidate_details"));
  const formatTwoDigit = (num) => String(num).padStart(2, "0");

  let isFeedback = candidateTokenDetails?.configuration?.feedback;
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 700,
        lg: 1200,
        xl: 1536,
      },
    },
  });

  const handlePrint = () => {
    window.print();
  };

  const totalQuestions = questionsList
    ? Object.keys(questionsList).length
    : 0;

  const attemptedQuestions = questionsList
    ? Object.values(questionsList).filter(
      (q) =>
        q.status === "ANSWERED" ||
        q.status === "ANSWERED_AND_MARKED"
    ).length
    : 0;

  const notAttemptedQuestions = totalQuestions - attemptedQuestions;

  const data = [
    {
      title: "Center Name",
      val: `: ${candidateTokenDetails?.configuration?.venueName}`,
    },
    {
      title: "Candidate Name",
      val: `:  ${candidateData?.candidateName}`,
    },
    {
      title: "Roll No",
      val: `:  ${candidateData?.rollNo}`,
    },
    {
      title: "Exam Date",
      val: `:  ${dayjs(candidateData?.startTime).format("DD MMM, YYYY")}`,
    },
    {
      title: "Total Questions",
      val: `: ${totalQuestions}`,
    },
    {
      title: "Total Attempted",
      val: `: ${formatTwoDigit(attemptedQuestions)}`,
    },
    {
      title: "Total Not Attempted",
      val: `: ${formatTwoDigit(notAttemptedQuestions)}`,
    },

  ];
  
  useEffect(() => {
    checkAuth(navigate)
  }, [])

  useEffect(() => {
  if (candidateTokenDetails && questionsList == undefined) {
    setIsReady(true);
  }
}, [candidateTokenDetails, questionsList]);


useEffect(() => {
  if (isReady === false) return;

  if (!candidateTokenDetails || !questionsList) {
    navigate(`/${Cookies.get("test_engine_project")}/login`, { replace: true });
  }
}, [isReady, candidateTokenDetails, questionsList, navigate]);


  const handleFeedback = async () => {
    localStorage.setItem('isInFeedback', true)
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Feedback Review",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    const formData = {
      imageSize: "L",
      language: "english",
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: feedbackActions.GET_FEEDBACK_QUESTIONS,
      payload: {
        data: encodedData,
        formData: formData,
        navigate: navigate,
      },
    });
  };

  const handleExit = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Exit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    Cookies.remove("test_engine_token");
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace(`/${Cookies.get("test_engine_project")}/login`);
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
             minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    backgroundColor: "#EBF2FF",
    margin:"auto",
    overflowX: "hidden",
    py: 4,
        }}
      >
        <Container maxWidth="md" disableGutters sx={{ px: 2 }}>
          <Box
            sx={{
              p: 3,
              bgcolor: "#fff",
              textAlign: "center",
            }}
          >
            <img src={ThankyouIcon} alt="Thank you" height={150} width={150} />
            <Typography
              sx={{
                fontWeight: "bold",
                color: "rgba(63, 65, 209, 1)",
                fontSize: { xs: "16px", md: "24px" },
                pt: 2,
                pb: 2,
              }}
            >
              Thank you! <br />
              Your Exam Submitted Successfully.
            </Typography>
            {data?.map((v, i) => (
              <Grid
                container
                key={i}
                p={1}
                sx={{
                  borderBottom: "1px solid rgba(30, 30, 30, 0.1)",
                  color: "#1E1E1E",
                  alignItems: "flex-start",   //  important
                }}
              >
                {/* TITLE */}
                <Grid
                  item
                  xs={6}      
                  sm={4}
                  md={4}
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: "bold",
                    textAlign: "start",
                    whiteSpace: "nowrap",     //  title ek line me rahe
                  }}
                >
                  {v?.title}
                </Grid>
                {/* VALUE */}
                <Grid
                  item
                  xs={6}      //  mobile width
                  sm={8}
                  md={7}
                  sx={{
                    fontSize: { xs: "14px", md: "16px" },
                    lineHeight: "20px",
                    textAlign: "start",
                    fontWeight: 400,

                    wordBreak: "break-word",   //  wrap long text
                    overflowWrap: "anywhere",  // force wrap
                  }}
                >
                  {v?.val}
                </Grid>
              </Grid>
            ))}
            <Grid
              container
              pt={2}
              spacing={2}
              justifyContent="center"
            >
              {/* EXIT BUTTON */}
              <Grid item xs={12} md={6}>
                <Button
                  onClick={handleExit}
                  sx={{
                    width: "100%",               // 🔥 full width on mobile
                    color: isFeedback
                      ? "rgba(63, 65, 209, 1)"
                      : "white",
                    backgroundColor: isFeedback
                      ? "white"
                      : "rgba(63, 65, 209, 1)",
                    border: "1px solid rgba(63, 65, 209, 1)",
                    borderRadius: "20px",
                  }}
                >
                  Exit
                </Button>
              </Grid>

              {/* PRINT BUTTON */}
              <Grid item xs={12} md={6}>
                <Button
                  onClick={handlePrint}
                  sx={{
                    width: "100%",               // 🔥 full width on mobile
                    color: "rgba(63, 65, 209, 1)",
                    backgroundColor: "white",
                    border: "1px solid rgba(63, 65, 209, 1)",
                    borderRadius: "20px",
                  }}
                >
                  Print
                </Button>
              </Grid>

              {/* FEEDBACK BUTTON (optional) */}
              {isFeedback && (
                <Grid item xs={12}>
                  <Button
                    onClick={handleFeedback}
                    sx={{
                      width: "100%",
                      color: "white",
                      backgroundColor: "rgba(63, 65, 209, 1)",
                      border: "1px solid rgba(63, 65, 209, 1)",
                      borderRadius: "20px",
                    }}
                  >
                    Continue to Feedback
                  </Button>
                </Grid>
              )}
            </Grid>

          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
